import React from 'react';
import { Admin, Resource, EditGuesser, ListGuesser, ShowGuesser, Login } from 'react-admin';
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import devices from './devices';
import { Dashboard } from './dashboard';
import UserIcon from '@material-ui/icons/People';
import ErrorIcon from '@material-ui/icons/ErrorOutline';

const CustomLoginPage = () => <Login backgroundImage="/background.jpg" />;

const App = () => (
    <Admin loginPage={CustomLoginPage} authProvider={authProvider} dataProvider={dataProvider} dashboard={Dashboard}>
	    <Resource name="users" list={ListGuesser} edit={EditGuesser} show={ShowGuesser} icon={UserIcon}/>
        <Resource name="devices" {...devices} />
        <Resource name="alerts" list={ListGuesser} edit={EditGuesser} show={ShowGuesser} icon={ErrorIcon} />
    </Admin>
);

export default App;
